import React, { useEffect } from 'react'
import UserPage from '../../common/UserPage/UserPage';
import Footer from '../../common/Footer/Footer';
import TherapistSettings from '../../components/UserTherapyPlanner/TherapistSettings'
import { useDispatch, useSelector } from 'react-redux'
import { getCurrentTherapist } from '../../redux/therapistSlice'

function TherapistSettingsPage() {
        const dispatch = useDispatch();

  const therapistState = useSelector((state) => state.therapist) || {};
  const { therapist} = therapistState;

  useEffect(() => {
    dispatch(getCurrentTherapist());
  }, [dispatch]);
  return (
    <div>
    <UserPage customImage={therapist?.picture} />
    <TherapistSettings />
    <Footer />
    </div>
  )
}

export default TherapistSettingsPage